import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import materials from '@components/ui-components/materials/component.js'
import caseItem from '@components/ui-components/case/component.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      decisionsSwiper: {
        spaceBetween: 32,
        parallax: true,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          el: '.js-decisions-pag',
          clickable: true,
        },
        breakpoints: {
          1160: {
            spaceBetween: 16,
          },
        },
      },
      visibleText: false,
      visibleBtn: false,

      heightFull: null,
      heightHide: null,
      height: null,
      swiperOther: {
        slidesPerView: 'auto',
        spaceBetween: 32,
        speed: 500,
        grabCursor: true,
        navigation: {
          nextEl: '.js-decisions-next',
          prevEl: '.js-decisions-prev',
        },
        breakpoints: {
          1160: {
            spaceBetween: 24,
          },
          920: {
            spaceBetween: 16,
          },
        },
      },
      isEndSlide: false,
      isFirstSlide: true,
    }
  },
  components: {
    'page-form-cmp': PageForm,
    'materials-cmp': materials,
    'case-cmp': caseItem,
  },
  methods: {
    openDesc() {
      this.visibleText = !this.visibleText
      if (this.visibleText) {
        this.height = this.heightFull
      } else {
        this.height = this.heightHide
      }
    },
    startSwipe() {
      if (this.$refs.sliderOther) {
        this.isEndSlide = this.$refs.sliderOther.swiper.isEnd
        this.isFirstSlide = this.$refs.sliderOther.swiper.isBeginning
      }
    },
    calcHeight() {
      let leftHeight = this.$refs.containerLeft.clientHeight
      let rightHeight = this.$refs.containerRight.clientHeight
      if (leftHeight > rightHeight && leftHeight > 400) {
        this.visibleBtn = true
        setTimeout(() => {
          this.heightFull = this.$refs.containerLeft.clientHeight
          this.heightHide = Math.max(rightHeight, 400)
          this.height = Math.max(this.heightHide, 400)
        }, 10)
      } else {
        this.visibleText = true
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.startSwipe()
      this.calcHeight()
    }, 100)
  },
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        this.template = data.data
        this.visibleText = false
        this.visibleBtn = false

        this.heightFull = null
        this.heightHide = null
        this.height = null

        this.isEndSlide = false
        this.isFirstSlide = true

        setTimeout(() => {
          this.calcHeight()
        }, 100)
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/decisions/category/id/index.js